// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_3GxTg1ZOfzQBhqgb5SK0sz","row":"_1alcBmf5VVRRk-yZnl3YtN"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Partners/styles.scss
 ** module id = 455
 ** module chunks = 0
 **/